
import { Vue, Component, Prop } from "vue-property-decorator";
@Component({})
export default class PhoneInput extends Vue {
  @Prop(Object) phone!: any;
  @Prop(Object) errorPhone!: any;
}
